import axios from "axios";

const getImage = (id, callback) => {
    const config = {
        url: `/api/images/${id}`,
        method: 'GET',
        responseType: "blob"
    }

    axios.request(config)
        .then(response => callback(response.data))
}

const updateImage = (id, image, callback) => {
    const config = {
        url: `/api/images/${id}`,
        method: 'PUT',
        data: image,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }

    axios.request(config)
        .then(response => callback(response.data))
}

const uploadImage = (image, callback) => {
    const formData = new FormData();
    formData.append("file", image);

    const config = {
        url: "/api/images/upload",
        method: "POST",
        data: formData
    };

    axios.request(config)
        .then(response => callback(response.data))
};

const deleteImage = (id, callback) => {
    const config = {
        url: `/api/images/${id}`,
        method: "DELETE"
    }

    axios.request(config).then(response => callback(response.data));
}

const imageActions = {
    getImage,
    updateImage,
    uploadImage,
    deleteImage
}

export default imageActions;